import { zIndexModal } from '@calendly/ui/z-index';
/**
 * Stack ET-editor overlays (Popup/SimplePopup, phone menus) above the side panel.
 * Mobile side panel is zIndexSidePanel (250); nested ET panel uses zIndexModal (500).
 * CUI FixedContainer defaults to z-index 15 — pass this via Modal/Popup/SimplePopup
 * `zIndex` or DropdownMenu `mobileMenuStyle` / `menuStyle`.
 */
export const etEditorOverlayZIndex = zIndexModal + 1;

/**
 * Popups opened inside an ET-editor overlay (e.g. DatePopup from DefaultAvailabilityModal).
 * Must sit above {@link etEditorOverlayZIndex} so focus lock / scrim order stays correct.
 */
export const etEditorNestedOverlayZIndex = etEditorOverlayZIndex + 1;

/** Menu layer for dropdowns portaled inside an ET-editor overlay modal (e.g. ActiveOn on mobile). */
export const etEditorNestedMenuLayerStyle = {
  zIndex: etEditorNestedOverlayZIndex
};

/**
 * Apply to CUI Modal root (className). FixedContainer defaults to z-index 15,
 * below the mobile side panel (250+). Prefer `zIndex={etEditorOverlayZIndex}` on
 * Modal/Popup/SimplePopup when available (@calendly/ui >= 10.18.14).
 */
export const modalRootStackingCss = "m1hzbkka";

/**
 * Modals opened while the settings IA {@link CenteredOverlay} is visible. CUI
 * CenteredOverlay and Modal both default to zIndexLowestModal (15); later portals
 * can still lose pointer events when focus lock / scrim order conflicts, so stack
 * at the standard modal layer. Must stay below zIndexNotification (550) so global
 * success/error toasts remain visible while the modal is still open (e.g. invite flow).
 */
export const modalAboveOverlayStackingCss = "m1jf15cn";

require("./modal_stacking.wyw-in-js.css!=!../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./modal_stacking.js");